import React, { memo } from 'react';
import { withTheme } from 'emotion-theming';
export var SearchBlock = /*#__PURE__*/memo(withTheme(function (_ref) {
  var _ref$theme = _ref.theme,
      _ref$theme$colors = _ref$theme.colors,
      primary = _ref$theme$colors.primary,
      secondary = _ref$theme$colors.secondary,
      SITE_NAME = _ref$theme.SITE_NAME,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? SITE_NAME === 'bdc' ? secondary : primary : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#FFFFFF' : _ref$stroke;
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: 'new 0 0 60 60'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: color,
    width: "60",
    height: "60"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    d: "M26.9,32.9c-3.5-2.8-4-7.9-1.2-11.3c2.8-3.5,7.9-4,11.3-1.2c3.5,2.8,4,7.9,1.2,11.3 C35.4,35.2,30.3,35.7,26.9,32.9z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "26.7",
    y1: "33.1",
    x2: "20.1",
    y2: "41.3"
  })));
}));